import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  PROJECTS_STORE,
  JOBS_STORE,
  EDUCATION_STORE,
  SKILLS_STORE,
  TOOLS_STORE,
  COMPANIES_STORE,
} from '@dges/modules/portfolio/domain';
import { ProjectsFacade } from './projects/projects.facade';
import { JobsFacade } from './jobs/jobs.facade';
import { EducationFacade } from './education/education.facade';
import { SkillsFacade } from './skills/skills.facade';
import { ToolsFacade } from './tools/tools.facade';
import { CompaniesFacade } from './companies/companies.facade';

/**
 * Binds every portfolio store contract to its NgRx facade implementation.
 * Call once at the app composition root.
 */
export function providePortfolioNgrxStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: PROJECTS_STORE, useExisting: ProjectsFacade },
    { provide: JOBS_STORE, useExisting: JobsFacade },
    { provide: EDUCATION_STORE, useExisting: EducationFacade },
    { provide: SKILLS_STORE, useExisting: SkillsFacade },
    { provide: TOOLS_STORE, useExisting: ToolsFacade },
    { provide: COMPANIES_STORE, useExisting: CompaniesFacade },
  ]);
}
